const endpointTypeToUrl = {
    local: 'http://localhost:8060/monitoring-api/api/v1/ui',
    dev: 'https://niketeam-api-stg.nike.net/monitoring-api/api/v1/ui',
    qa: 'https://niketeam-api-stg.nike.net/monitoring-api/api/v1/ui',
    stg: 'https://niketeam-api-stg.nike.net/monitoring-api/api/v1/ui',
    prod: 'https://niketeam-api.nike.net/monitoring-api/api/v1/ui'
};
const endpointTokenToType = {
    'local': 'local',
    'dev': 'dev',
    'qa': 'qa',
    'stg': 'stg'
};
function calculateEndpointToken(locationOrigin) {
    if (
        locationOrigin.toLowerCase().includes("localhost")
    ) {
        return 'local';
    }

    return locationOrigin.split('.', 1)[0].split(/[-]+/).pop();
}
export default function apiBaseUrl(locationOrigin) {
    let endpointToken = calculateEndpointToken(locationOrigin);
    const type = endpointTokenToType[endpointToken];
    if(type) {
        return endpointTypeToUrl[type];
    } else {
        return endpointTypeToUrl['prod'];
    }
}



// WEBPACK FOOTER //
// ./src/service/apiBaseUrl.js